import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => console.log('SW registered:', reg.scope))
      .catch((err) => console.log('SW registration failed:', err));
  });
}

// Hide Emergent badge
(function hideBadge() {
  const remove = () => {
    const el = document.getElementById('emergent-badge');
    if (el) el.remove();
  };
  remove();
  const obs = new MutationObserver(remove);
  obs.observe(document.body, { childList: true, subtree: true });
  setInterval(remove, 300);
})();
